import React from 'react';

// need to explicitly omit `onSelect` from native HTML <li> attributes to avoid collision
// eslint-disable-next-line @typescript-eslint/no-explicit-any

const ItemContext = /*#__PURE__*/React.createContext({});

const ListContext = /*#__PURE__*/React.createContext({});

export { ItemContext, ListContext };
